
import {Vue} from "vue-class-component";

export default class RegisterTermsConditions extends Vue {
}
